// extracted by mini-css-extract-plugin
export default {"doc":"Privacy_doc__n0Q9m"};